import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../Component/Button";
import UserSidebar from "../../Component/UserSidebar";
import { useForm } from "react-hook-form";
import { Row, Col, Form } from "react-bootstrap";
import { updateUserAvailability } from "./Slice/availabilitySlice";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";

function SidebarRemoveClass() {
  document.getElementById("OnscrollBody").classList.remove("show_sidebar");
}

function SidebarAddClass(e) {
  e.preventDefault();
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}

const Index = (props) => {

  let todayDate = new Date();
  todayDate.setMonth(todayDate.getMonth());
  todayDate = todayDate.toLocaleDateString();

  const d = new Date();
  d.setMonth(d.getMonth() + 3);
  const nextThreeMonthData = d.toLocaleDateString();

  const userInfo = useSelector((state) => state.userInfo || {});
  const { updateProfileData, loading, } = useSelector((state) => state?.availability);

  const { title } = props;
  const [fromDate, setFromDate] = useState(todayDate);
  const [toDate, setToDate] = useState(nextThreeMonthData);
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const { handleSubmit } = useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = title;
  }, [title, userInfo]);

  useEffect(() => {
    if (updateProfileData.avail_start_time) {
      setFromDate(updateProfileData.avail_start_time);
    }
    if (updateProfileData.avail_end_time) {
      setToDate(updateProfileData.avail_end_time);
    }
  }, [updateProfileData]);

  const onSubmit = (data) => {
    if (!userInfo?.id) {
      return;
    }

    const payload = {
      avail_start_time: fromDate,
      avail_end_time: toDate,
      // add more fields if needed
    };

    dispatch(
      updateUserAvailability({
        data: payload,
        userId: userInfo.id || updateProfileData.id
      })
    ).unwrap().then((res) => {
      // Optional: handle success (e.g., show a success message)
      setPopupMessage(res.message || "Availability updated successfully.");
      setShowPopup(true);
    })
      .catch((err) => {
        // Optional: handle error (e.g., show an error message)
        setPopupMessage(err.message || "Failed to update availability.");
        setShowPopup(true);
      });
  };

  return (

    <div>
      <div className="dashboard_outer">
        <UserSidebar />
        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to=""
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>

          <h2 className="page_heading mb-3">Availability</h2>

          <div className="box shadow bg-white p-4">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col md={6} className="mt-4">
                  <Form.Group>
                    <Form.Label>From Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                {/* To Date */}
                <Col md={6} className="mt-4">
                  <Form.Group>
                    <Form.Label>To Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                {/* Submit Button */}
                <Col md={3}>
                  <div className="form-group mt-3">
                    <Button
                      title={loading ? "Submitting..." : "Submit"}
                      className="btn w-100 loginsubmit"
                      disabled={loading}
                    />
                  </div>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
      <button type="button" className="sidebar_overlay" onClick={SidebarRemoveClass}></button>

      <PopupModalWithOk
        show={showPopup}
        onHide={() => {
          setShowPopup(false);
        }}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />

    </div>
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Index;
